import { Button, Space } from 'antd'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { BuildOutlined, SettingOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { parseDate } from '../../../../config/dayjsConfig'
import { DatePicker } from '../../../../components/Form'
import { customReportDateSelector } from '../../../../redux/context/customReports/selectors'
import { setCustomReportDate } from '../../../../redux/context/customReports/actions'
import { LayoutsContext, LayoutsContextType } from './layout/LayoutContext'
import { useCtxCustomReportStructure } from '../../../../features/customReport/queries/structure/useCtxCustomReportStructure'
import CtxCustomReportTreeSelect from '../../../../features/customReport/components/treeSelect/CtxCustomReportTreeSelect'
import ArgumentsDropdown from './argument/ArgumentsDropdown'
import { useCalculatedReport, useCalculatedReportContext } from './CalculatedReportContext'

const PageHeaderExtra: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { data: calculatedReport } = useCalculatedReport()
  const { reportId, setReportId } = useCalculatedReportContext()
  const date = useSelector(customReportDateSelector)
  const { setLayoutEdit } = useContext(LayoutsContext) as LayoutsContextType
  const { isPending: treeIsPending } = useCtxCustomReportStructure()

  const setDate = (newDate: string) => {
    dispatch(setCustomReportDate(newDate))
  }

  const onReportChange = (id: number) => {
    setReportId(id)
  }

  return (
    <Space>
      <CtxCustomReportTreeSelect
        data-cy="report-tree-select"
        treeDefaultExpandAll
        value={reportId}
        disabled={treeIsPending}
        loading={treeIsPending}
        filterTreeNode={(inputval, node) => {
          return node && (node.title as string)?.toLowerCase().includes(inputval?.toLowerCase())
        }}
        onChange={onReportChange}
      />
      <DatePicker
        data-cy="report-date-picker"
        style={{ width: 100, height: '100%' }}
        key="datePicker"
        showWeek
        allowClear={false}
        defaultValue={parseDate(date)}
        format={{
          format: 'YYYY-MM-DD',
          type: 'mask'
        }}
        onChange={(newDate, newDateString) => {
          if (newDate && typeof newDateString === 'string') {
            setDate(newDateString)
          }
        }}
      />
      <ArgumentsDropdown defaultArguments={calculatedReport?.args} reportId={calculatedReport?.id} />
      <Button data-cy="layout-edit-button" icon={<BuildOutlined />} onClick={() => setLayoutEdit(true)}>
        {t('global:layout')}
      </Button>
      <Button
        data-cy="settings-button"
        icon={<SettingOutlined />}
        onClick={() => navigate('/settings/custom-report/order')}
      >
        {t('header:settings')}
      </Button>
    </Space>
  )
}

export default PageHeaderExtra
